import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components
import Button from "components/CustomButtons/Button.js";
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Tooltip from "@mui/material/Tooltip";
import CardMedia from '@mui/material/CardMedia';
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import styles from "../ServicesSections.module.scss";



export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={8} md={8}>
        <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>
          What history can teach us about data visualization?
          </h3>
          <p> 

          Take a look at these data visualizations...
          <br /> <br /> 

          They help show the power of data visualisation to convey drab or complex data in powerful and instinctive ways. As beautiful as they are - handcrafted and neatly put together - they are not merely a "convenient" way of communication.

          <br /> <br /> 
          They were hugely influential in changing policy, ideas, ignorant views and dramatically helping society move forward in a positive way. 
            </p> 

          </GridItem>

          

          <GridItem xs={12} sm={10} md={10} className={classes.section} style={{paddingTop:"10px"}}>
        
            <GridContainer > 
              
            <GridItem xs={12} sm={6} md={6}>
            <div style={{textAlign: "center",maxWidth:"378px",width:"100%", marginLeft:"auto", marginRight:"auto"}}>
              <img
                src="https://engines.egr.uh.edu/sites/engines/files/images/page/coxcombchart.jpg"
                alt="..."
                className={imgClasses}
              />
              <div style={{textAlign:"center"}}><i><br />FLORENCE NIGHTINGALES' POLAR MAPS (ALSO KNOWN AS COXCOMBS) FROM THE CRIMEAN WAR (1853-1856) <br />Courtesy: of <a href="https://engines.egr.uh.edu/episode/1712">University of Houston </a>  </i></div>
              </div>
            </GridItem>

            <GridItem xs={12} sm={6} md={6}>
            <div style={{textAlign: "center",maxWidth:"358px",width:"100%", marginLeft:"auto", marginRight:"auto"}}>
              <img
                src="https://cdns.tblsft.com/sites/default/files/blog/6_32.png"
                alt="..."
                className={imgClasses}
              />
              <div style={{textAlign:"center"}}><i><br />W.E.B. DU BOIS DATA VISUALIZATION SERIES AT THE EXPOSITION UNIVERSELLE IN PARIS 1900. <br />Courtesy: of <a href="https://www.uh.edu/engines/epi1712.html">Tableau</a> </i></div>
              </div>
            </GridItem>
            </GridContainer>
            </GridItem>

            <GridItem xs={12} sm={8} md={8}>

          <p> 
            <br /><br />
            <br />
          Take another look at those dates: 1850s and 1900... these visualizations would look cutting edge in any dashboard today! They show that Data Visualization isnt about the latest technical tool or wizbang data plugin. It is about the data. It is about the story you can tell. Once you have interesting data and an interesting story to tell, you can get extremely creative.. and possibly even change the world! 😀
          </p> 
          <h3 className={classes.title}>
          Check out our data studio work! 
          </h3>
 <p>One of the main tools we work with here at Tribalism is Google Data Studio. Data Studio is a free tool by Google that allows you to develop professional looking dashboards and connect them to a variety of data sources. To see more on data studio and in particlualr our work on it - including some free templates! please go here:
 </p>
          </GridItem>

              <GridItem xs={12} sm={8} md={8}>
                <Card
                  raised
                  //background
                  //style={{
                  //  backgroundImage: "url('/img/sections/services/google-analytics-training/1.jpg')",
                  //}}
                >
                  
                  <CardActionArea>
                    <CardMedia
                      component="iframe"
                      //alt="Contemplative Reptile"
                      //className={classes.media}
                      height="340"
                      image="https://datastudio.google.com/embed/reporting/878d139c-25b5-41b0-846b-ef6603d82e60/page/48mXB"
                      //image="/img/sections/services/google-analytics-training/1.jpg"
                      title="Contemplative Reptile"
                    />
                    <CardContent>
                    
                    <Typography variant="subtitle1">SEO - SERP POSITION BY BAND DASHBOARD - DOWNLOADABLE TEMPLATE</Typography>
                    <Typography variant="caption">
                    This clever SEO dashboard allows you to circumvent the dreaded "cant mix metrics and dimensions in case statements" issue by making use of the Extract Data function in data studio, applying this to search console and then applying the transformations to the resultant data. The result is an awesome data set that splits down your Keywords by Position band - eg 1-5, 5-10 etc.
                    </Typography>

                    </CardContent>
                  </CardActionArea>
                </Card>         
              </GridItem>
              
              

          
          <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>
          Work with us!
          </h3>
          <p> 
 
          
          Data is hard to understand for anyone if its just presented in tables or text files. If you are interested in develeloping some awesome dashboards but lacking a little expertise, we can help! For as little as $2000+gst we can have one of our awesome<a href="/team">dashboard consultants</a>  work with you to turn out an awesome and useful data studio dashboard connected to your particular data assets, in no time. 😀
            
            </p> 

          </GridItem>

          
      </GridContainer>
    </div>
  );
}
